var _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Service, { inject as service } from '@ember/service';
import { setItemSubunitsServiceMerchantSubunits } from '@square/dashboard-utilities/utils/item-subunits';
import { assert } from '@ember/debug';
import { tracked } from '@glimmer/tracking';
/**
 * Used by items-v3-base and other items library routes to get a list of the merchant's item subunits.
 */
let ItemSubunits = (_class = class ItemSubunits extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "merchantSubunitStore", _descriptor, this);
    _initializerDefineProperty(this, "store", _descriptor2, this);
    _initializerDefineProperty(this, "selectedSubunit", _descriptor3, this);
  }
  getSelectedSubunit() {
    return this.selectedSubunit;
  }
  setSelectedSubunit(subunit) {
    this.selectedSubunit = subunit;
  }
  async fetchMerchantSubunits() {
    assert('ItemSubunits requires the MerchantSubunitStore service', typeof this.merchantSubunitStore !== 'undefined');
    const [allForMerchant, authorized] = await Promise.all([this.store.findAll('merchant-subunit-ed'), this.merchantSubunitStore.findAuthorized()]);
    setItemSubunitsServiceMerchantSubunits(allForMerchant.toArray(), true);
    setItemSubunitsServiceMerchantSubunits(authorized);
    return authorized;
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "merchantSubunitStore", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "selectedSubunit", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
})), _class);
export { ItemSubunits as default };